import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  hasResponse: false,
  hasError: false,
  isRequestPending: false,
  responseData: null,
  errorCode: null,
  errorMessage: null,
}

const prePaymentSlice = createSlice({
  name: 'prePayment',
  initialState,
  reducers: {
    updateBalancePending: (state,{ payload }) => ({
      ...state,
      isRequestPending: payload,
    }),
    updateBalanceData: (state, { payload }) => ({
      ...state,
      ...payload,
      hasResponse: true,
      hasError: false,
      isRequestPending: false,
    }),
    balanceCheckError: (state, { payload }) => ({
      ...state,
      ...payload,
      hasResponse: true,
      hasError: true,
      isRequestPending: false,
    }),
    clearBalanceData: state => ({
      ...state,
      hasResponse: false,
      hasError: false,
      isRequestPending: false,
      errorCode: null,
      errorMessage: null,
    }),
  },
})

export const {
  updateBalancePending,
  updateBalanceData,
  balanceCheckError,
  clearBalanceData,
} = prePaymentSlice.actions

export const prePaymentSelector = state => state.prePayment

export default prePaymentSlice.reducer
